import { FC, PropsWithChildren } from "react";

export const SheetHeader: FC<PropsWithChildren> = ({ children }) => (
  <div className="chrome-row flex shrink-0 flex-row items-center border-b-[0.5px] px-5 text-sm">{children}</div>
);
